// 分類・本社確認・リスクの Badge 表示。
import { Badge } from "../../components/ui";
import {
  CLASSIFICATION_BADGE,
  HQ_REVIEW_STATUS,
  HQ_REVIEW_TONES,
  RISK_LEVELS,
  RISK_TONES,
  labelOf,
} from "../../masters";

export function ClassificationBadge({ value }: { value: string | null }) {
  if (!value) return <span className="text-slate-400">—</span>;
  const meta = CLASSIFICATION_BADGE[value];
  if (!meta) return <Badge tone="gray">{value}</Badge>;
  return <Badge tone={meta.tone}>{meta.label}</Badge>;
}

export function HqStatusBadge({ value }: { value: string | null }) {
  if (!value) return <span className="text-slate-400">—</span>;
  return <Badge tone={HQ_REVIEW_TONES[value] ?? "gray"}>{labelOf(HQ_REVIEW_STATUS, value)}</Badge>;
}

export function RiskBadge({ value }: { value: string | null }) {
  if (!value) return <span className="text-slate-400">—</span>;
  return <Badge tone={RISK_TONES[value] ?? "gray"}>{labelOf(RISK_LEVELS, value)}</Badge>;
}
